import { CookieStore, Query, dataStore, runtime } from './runtime';
import { Dropdown, Elements, Input } from './ui';

export class Application {
    public state: boolean;

    constructor() {
        runtime.cookie = new CookieStore();
        runtime.elements = new Elements();
        runtime.query = new Query();
        this.state = false;
    }

    public start() {
        runtime.query.afterLoad();
        $('body').on('click', (event) => runtime.elements.checkUnDropdown(event));

        $("*[data-bind=dropdown]").each((index, element) => runtime.elements.addDropdown(new Dropdown(element as Element)));
        $("*[data-bind=input]").each((index, element) => runtime.elements.addInput(new Input(element as Element)));

        runtime.elements.refreshSteps();
        runtime.cookie.setElements();
    }

    public load() {
        if (!$('html').hasClass('ie-8')) {
            $('#no-js').remove();
        }

        jQuery.ajax({
            url: 'src/language/versions.json',
            dataType: 'json',
            cache: false,
            success: (data) => {
                dataStore.value = data;
                this.state = true;
            }
        });
    }
}
